/**
 * 특정 name의 쿠키 Value를 반환한다.
 * @param name
 * @return {string}
 */
export default function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()[]\/+^])/g, '$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}



// WEBPACK FOOTER //
// ./src/common/util/auth/getCookie.js